import React, { useState } from 'react';

const card = { background: '#0F0F11', border: '1px solid #27272A' };
const mono = { fontFamily: 'JetBrains Mono, ui-monospace, monospace' };

/**
 * 2026-05-27 — production mitigation. Wraps a heavy admin panel that
 * auto-fetches on mount, gating it behind an explicit "Carica" click so
 * the dashboard does not fire 5+ heavy parallel requests at page-load.
 *
 * The wrapped panel is fully unmounted until the user clicks the
 * button, so no useEffect / useCallback inside it runs.
 *
 * Props:
 *   - label: human-readable section title shown before load
 *   - description: optional one-liner hint
 *   - testid: data-testid for the placeholder/load button
 *   - children: the panel to mount on demand
 */
export default function LazyMountGate({ label, description, testid, children }) {
  const [mounted, setMounted] = useState(false);

  if (mounted) {
    return children;
  }
  return (
    <div
      className="rounded-sm p-4 mt-3 flex items-center justify-between gap-3"
      style={card}
      data-testid={testid || 'lazy-mount-gate'}
    >
      <div>
        <div
          className="text-[10px] uppercase tracking-wider text-zinc-500"
          style={mono}
        >
          {label}
        </div>
        {description && (
          <div
            className="text-[10px] text-zinc-600 italic mt-0.5"
            style={mono}
          >
            {description}
          </div>
        )}
      </div>
      <button
        type="button"
        data-testid={`${testid || 'lazy-mount-gate'}-load-btn`}
        onClick={() => setMounted(true)}
        className="px-3 py-1.5 rounded-sm text-[11px] border border-violet-700 text-violet-300 hover:bg-violet-950/40"
        style={mono}
      >
        Carica
      </button>
    </div>
  );
}
